import { render, staticRenderFns } from "./DatasourceItem.vue?vue&type=template&id=6d428272"
import script from "./DatasourceItem.vue?vue&type=script&lang=js"
export * from "./DatasourceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports